@if (card.data && card.context.use_new_ui === true) {
    <div class="vertical">
        <div class="headline-container" (click)="openLink(headline_articles)">
            <div class="headline-content-container">
                @if (isVideo) {
                    <app-media-chrome-player [src]="videoSources"></app-media-chrome-player>
                }
                <!-- <app-plyr
        *ngIf="isVideo"
        [plyrSources]="videoSources"
        [plyrOptions]="options"
        (plyrInit)="plyrInit($event)"
        class="video"
      ></app-plyr> -->
                <img class="conbritutor-img" [src]="header_img || default_img" [style]="{ maxHeight: header_img ? 'auto' : '100%' }" />
                <div class="headline-article">
                    <div class="headline-title">{{ is_feed_component ? headline_articles.description : headline_articles.title }}</div>
                    <div class="headline-footer">
                        @if ((is_feed_component && headline_articles.user_full_name) || (!is_feed_component && headline_articles.author)) {
                            <div class="articles_author">
                                {{ is_feed_component ? headline_articles.user_full_name : headline_articles.author }}
                            </div>
                        }
                        @if (headline_articles.publication_date) {
                            <div class="articles_date">{{ getDistanceDate(headline_articles.publication_date, now) }}</div>
                        }
                        @if ((!is_feed_component && headline_articles.contributor.logo_url) || (is_feed_component && headline_articles.user_image)) {
                            <div [class.feed-item-img-container]="is_feed_component" class="headline-img-container">
                                <img
                                    [class.headline-img]="!is_feed_component"
                                    [class.feed-headline-img]="is_feed_component"
                                    [src]="is_feed_component ? headline_articles.user_image : headline_articles.contributor.logo_url"
                                    alt=""
                                />
                            </div>
                        }
                    </div>
                </div>
                @if (card.context.display_tap_indicator) {
                    <img class="display-tap-indicator" src="https://res.cloudinary.com/bleachr/image/upload/v1652118759/TennisONE/T1%20Icons/click_tap4.png" alt="" />
                }
            </div>
        </div>
        <div class="article-container">
            @for (item of items; track item; let i = $index) {
                @if (i < 3 && i > 0) {
                    <article class="article-item" (click)="openLink(item)">
                        <div class="img-container">
                            <img class="img-article" [src]="handleBackgroundArticle(getFeedImg(item))" [style.aspectRatio]="'4/3'" (error)="checkImage($event)" />
                            @if (showPlayBtn(item)) {
                                <img class="video-button-img" src="/assets/play_button.png" />
                            }
                        </div>
                        <div class="content">
                            @if (!is_feed_component) {
                                <h2 class="title">
                                    {{ item?.title }}
                                </h2>
                                <div class="item-date">
                                    {{ getDistanceDate(item.publication_date, now) }}
                                </div>
                                @if (item?.contributor?.logo_url) {
                                    <img class="content-img" (click)="seeAll()" [src]="item.contributor.logo_url" alt="" />
                                }
                            } @else {
                                <h2 class="title" [innerHTML]="parseDesc(item.description, item.feed_type ? item.feed_type : '')"></h2>
                                <div class="item-date">
                                    {{ getDistanceDate(item.publication_date, now) }}
                                </div>
                                @if (item?.user_image) {
                                    <div class="feed-item-img-container">
                                        <img class="feed-headline-img" (click)="seeAll()" [src]="item.user_image" alt="" />
                                    </div>
                                }
                            }
                        </div>
                    </article>
                }
            }
        </div>
        <div class="see-all" (click)="seeAll()" [style]="color_scheme === 'light' ? 'color: #000000' : 'color: #ffffff'">{{ seeAllBtnText }}</div>
    </div>
}
